import Page from '../../../../Components/Page'
import { BUSINESS_YOUR_EVENTS_LINK } from '../../../../Constants'
import SuccessImage from './SuccessImage'

type BusinessSuccessPageProps = {
  businessEventUUID: string
}

const BusinessSuccessPage = (_: BusinessSuccessPageProps): JSX.Element => {
  return (
    <Page
      metaTitle='All done! - HeadBox'
      heading={<span style={{ color: '#1F1F1F' }}>Brilliant! Enquiry submitted.</span>}
      className='business-success-page fade-in'>
      <div
        style={{
          fontWeight: 600,
          fontSize: '18px',
          lineHeight: '24px',
          color: '#434343',
          textWrap: 'balance',
        }}>
        💌&nbsp;
        {`Many thanks for submitting your event brief!
        A member of our Meetings and Events team will be in touch shortly`}
        &nbsp;💌
      </div>
      <SuccessImage style={{ margin: '32px 0' }} />
      <div>
        <a
          href={BUSINESS_YOUR_EVENTS_LINK}
          style={{
            fontFamily: 'Montserrat',
            fontSize: 16,
            fontWeight: 600,
            textAlign: 'center',
            color: 'var(--primary)',
            textDecoration: 'none',
          }}>
          Back to HeadBox
        </a>
      </div>
    </Page>
  )
}

export default BusinessSuccessPage
